// Sign-in hero photo. Preloaded once at app start and kept decoded in memory so the
// <img> on the sign-in screen paints instantly (no late pop-in, no re-download on remount).
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1600&q=80'

let heroImage: HTMLImageElement | null = null
let heroReady = false

export function isHeroReady() {
  return heroReady
}

export function preloadHeroImage() {
  if (heroImage || typeof document === 'undefined') return
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'image'
  link.href = HERO_IMAGE_URL
  document.head.appendChild(link)

  heroImage = new Image()
  heroImage.decoding = 'async'
  heroImage.src = HERO_IMAGE_URL
  const markReady = () => {
    heroReady = true
  }
  if (typeof heroImage.decode === 'function') {
    heroImage.decode().then(markReady, markReady)
  } else {
    heroImage.onload = markReady
  }
}
